import { Box, Tooltip, Button, alpha, useTheme } from "@mui/material";
import React from "react";
import { borderRadius } from "../constants";
import Loading from "./Loading";

const CountComponent = ({ title, data, icon, iconStyle, fontWeight = 0, loading, retryFetchFunction, initialQuery, isPatientCountLoading }) => {
  const theme = useTheme();
  const showData = () => {
    if (isPatientCountLoading) {
      return <Loading />;
    }
    if (!loading) return (
      <Loading />
    );
    if (data?.response === "Retry") return <Button color="error" onClick={() => retryFetchFunction(initialQuery)}>Retry</Button>

    return (
      <Tooltip title={data?.toolTipLabel}>
        <Box
          sx={{
            fontSize: "1rem",
            fontWeight: fontWeight,
          }}
        >
          {data?.response}
        </Box>
      </Tooltip>
    )
  }
  return (
    <Box
      sx={{
        borderRadius: borderRadius,
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: theme.palette.mode === "dark" ? `0 4px 14px ${alpha("#000", 0.24)}` : undefined,
        display: "flex",
        alignItems: "center",
        padding: "8px",
        gap: "8px",
      }}
    >
      {icon !== undefined && (
        <Box sx={{ flexShrink: 0, display: "flex", alignItems: "center" }}>
          <Box sx={iconStyle}>{icon}</Box>
        </Box>
      )}
      <Box sx={{ textAlign: "center", flex: 1 }}>
        <Box
          sx={{
            fontSize: "0.87rem",
            color: theme.palette.text.secondary,
          }}
        >
          {title}
        </Box>
        {showData()}
      </Box>
    </Box>
  );
};

export default CountComponent;
